import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Landing from './pages/Landing'
import Play from './pages/Play'
import Daily from './pages/Daily'
import Curate from './pages/Curate'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/play" element={<Play />} />
        <Route path="/daily" element={<Daily />} />
        <Route path="/curate" element={<Curate />} />
      </Routes>
    </BrowserRouter>
  )
}
